import React, { useRef, useCallback, useState } from "react";
import {
  StyleSheet,
  View,
  TextInput,
  TouchableWithoutFeedback,
  StyleProp,
  ViewStyle,
  TextInputProps,
} from "react-native";
import { colors } from "src/assets";
import LocalText from "src/local";
import styled from "styled-components";

const ContentEditable = styled.div`
  flex: 1;
  font-size: 12px;
  color: ${colors.chokuBlack};
  margin-left: 8px;
  outline-style: none;
  &[data-placeholder]:empty:before {
    // content: attr(data-placeholder);
    content: "${LocalText.screens.review.commentInput
      .placeholder}"; // TODO: rebuild to attr ↑
    // color: attr(data-placeholder-text-color);
    color: ${colors.chokyGray10}; // TODO: rebuild to attr ↑
  }
`;

export const CommentIcon: React.FC = () => {
  return (
    <svg width="20" height="19.673" viewBox="0 0 20 19.673">
      <path
        d="M1.913,19.5a.7.7,0,0,1-.153-.84l1.13-2.173A3.9,3.9,0,0,1,0,12.724V8.335A3.893,3.893,0,0,1,3.889,4.447H4V3.888A3.893,3.893,0,0,1,7.892,0h8.22A3.892,3.892,0,0,1,20,3.888V8.277a3.893,3.893,0,0,1-3.888,3.889H16v.558a3.893,3.893,0,0,1-3.889,3.888H7.153L2.764,19.555a.7.7,0,0,1-.852-.059ZM1.392,8.335v4.389a2.5,2.5,0,0,0,2.5,2.5h.08a.7.7,0,0,1,.617,1.017l-.335.645,2.3-1.544a.7.7,0,0,1,.387-.118h5.167a2.5,2.5,0,0,0,2.5-2.5V8.335a2.5,2.5,0,0,0-2.5-2.5H3.889A2.5,2.5,0,0,0,1.392,8.335Zm4-4.447v.559h6.712A3.893,3.893,0,0,1,16,8.335v2.439h.115a2.5,2.5,0,0,0,2.5-2.5V3.888a2.5,2.5,0,0,0-2.5-2.5H7.892A2.5,2.5,0,0,0,5.4,3.888ZM4.123,12.774a.653.653,0,1,1,0-1.305h7.846a.653.653,0,1,1,0,1.305Zm0-2.811a.653.653,0,1,1,0-1.305h7.846a.653.653,0,1,1,0,1.305Z"
        fill="#7a7a7a"
      />
    </svg>
  );
};

export type CommentInputProps = Pick<
  TextInputProps,
  "value" | "onChangeText"
> & {
  containerStyle?: StyleProp<ViewStyle>;
};

export const CommentInput: React.FC<CommentInputProps> = ({
  containerStyle,
  value,
  onChangeText,
}) => {
  const htmlDivInputRef = useRef<HTMLDivElement>(null);
  const [localValue] = useState(value || "");
  const emitChange = useCallback(() => {
    onChangeText?.(htmlDivInputRef.current?.innerText || "");
  }, [onChangeText]);
  return (
    <TouchableWithoutFeedback onPress={() => htmlDivInputRef.current?.focus()}>
      <View style={[styles.root, containerStyle]}>
        <CommentIcon />
        <ContentEditable
          ref={htmlDivInputRef}
          onInput={emitChange}
          onBlur={emitChange}
          contentEditable
          data-placeholder={LocalText.screens.review.commentInput.placeholder}
          data-placeholder-text-color={colors.chokyGray10}
          dangerouslySetInnerHTML={{ __html: localValue }}
        />
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 16,
    backgroundColor: colors.chokuGray11,
  },
  input: {
    flex: 1,
    fontSize: 12,
    color: colors.chokuBlack,
    marginLeft: 8,
    outlineStyle: "none",
  },
});
